module.exports = __webpack_public_path__ + "img/delete.a16fe86d.svg";